import { styled } from 'parkdepot-shared/theme'

export const Container = styled<'section', { $bottomMobileMargin: boolean }>(
    'section',
    ({ $theme, $bottomMobileMargin = false }) => ({
        display: 'flex',
        gap: '10px',
        marginTop: 0,
        marginBottom: $bottomMobileMargin ? '12px' : 0,
        width: '100%',

        [$theme.mediaQuery.large]: {
            marginTop: '8px',
            marginBottom: 0
        }
    })
)

export const OpeningHourContainer = styled('div', ({}) => ({
    width: '100%'
}))

export const OpeningHours = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    color: '#000',
    fontWeight: 400,
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    lineHeight: '2.4rem'
}))

export const OpeningHoursTitle = styled('h2', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    color: '#000',
    fontWeight: 600,
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    lineHeight: '2.4rem',
    margin: 0
}))

export const OpeningHoursWrapper = styled('dl', ({ $theme }) => ({
    margin: 0
}))
